import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  getIdsOfTemplatesWithActiveNotifications,
  getMissingTemplateIdsForNotifications,
  getNotificationsForModule,
  getTemplateNotificationMessages,
  getTemplateNotificationsFetchStatus,
  makeGetNotificationRowKeysForTemplate,
  makeGetNotificationsForTemplate,
} from "./selectors";
import { ModuleId, TemplateId } from "../../../globalTypes";

export const useTemplateNotificationMessages = () =>
  useSelector((state) => getTemplateNotificationMessages(state));

export const useNotificationsForTemplate = (templateId: TemplateId) => {
  const getNotificationsForTemplate = useMemo(
    makeGetNotificationsForTemplate, // I <3 PRETTIER
    [templateId]
  );

  return useSelector((state) => getNotificationsForTemplate(state, templateId));
};

export const useNotificationCountForTemplate = (templateId: TemplateId) =>
  useNotificationsForTemplate(templateId).length;

export const useNotificationsForModule = (moduleId: ModuleId) =>
  useSelector((state) => getNotificationsForModule(state, moduleId));

export const useNotificationCountForModule = (moduleId: ModuleId) =>
  useNotificationsForModule(moduleId).length;

// extract specific data from notifications
export const useNotificationRowKeysForTemplate = (templateId: TemplateId) => {
  const getNotificationRowKeysForTemplate = useMemo(
    makeGetNotificationRowKeysForTemplate,
    [templateId]
  );

  return useSelector((state) =>
    getNotificationRowKeysForTemplate(state, templateId)
  );
};

export const useTemplateNotificationsFetchStatus = () =>
  useSelector(getTemplateNotificationsFetchStatus);

export const useMissingTemplateIdsForNotifications = () =>
  useSelector(getMissingTemplateIdsForNotifications);
